import { IPlayerAdapterAPI } from 'library/ts/player/adapter/IPlayerAdapterAPI';
import { PageAction } from 'skin/ts/Skin/model/PageAction';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { IMobileWebPageActionDataIn } from 'tag/ts/tag/interfaces/api/IMobileWebPageActionDataIn';
import { ISkinMobileWebAPIIn } from 'tag/ts/tag/interfaces/api/ISkinMobileWebAPIIn';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Simulation of Skin API for Mobile Web where we use default VTG player skin - Avia JS UI
 */
export class APISkinMobileWeb extends AbstractTagClass {
	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'APISkinMobileWeb'
			}
		);
	}

	/**
	 * @description Methods called on skin instance by page
	 */
	get IN(): ISkinMobileWebAPIIn {
		return <ISkinMobileWebAPIIn>{
			/**
			 * @description Page action passed to JS Skin application
			 * @param {IMobileWebPageActionDataIn} data
			 */
			pageAction: ( data: IMobileWebPageActionDataIn ): void => {
				this?.logger?.log(
					'pageAction:',
					'params:',
					data
				);
				// VTG player instance of this tag
				const player: IPlayerAdapterAPI = this.tag?.snapshot?.player;

				// filter per page action
				switch ( data.action ) {
					case PageAction.MUTE:
						if ( this.utils.Type.isDefined( player?.muted ) ) {
							player.muted = true;
						}
						break;
					case PageAction.UNMUTE:
						if ( this.utils.Type.isDefined( player?.muted ) ) {
							player.muted = false;
						}
						break;
				}
			}
		};
	}
}